import { ProductOffer } from '@/api/backend/contract/ProductList';

/**
 * Проверяет, нужно ли показывать селектор размеров
 * Не показываем, если оффер один и у него нет размера (пустая строка)
 */
export function shouldShowSizeSelector(
  productOffers: ProductOffer[] | undefined
): boolean {
  if (!productOffers || productOffers.length === 0) {
    return false;
  }

  // Если оффер один и у него нет размера (пустая строка), не показываем селектор
  if (productOffers.length === 1 && !productOffers[0].size) {
    return false;
  }

  return true;
}
